import { makeStyles } from '@mui/styles'

import TableSelect, { type TableSelectProps } from './TableSelect'

const useStyles = makeStyles(
  () => ({
    select: {
      width: 64,
    },
  }),
  { name: 'UnitsToggle' },
)

export type UnitSelectProps = TableSelectProps

const UnitSelect = (props: UnitSelectProps) => {
  const classes = useStyles()

  return (
    <TableSelect
      classes={{
        select: classes.select,
      }}
      keyProp="name"
      renderEmpty={false}
      {...props}
    />
  )
}

export default UnitSelect
